interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(current: number, total: number): (number | string)[] {
  if (total <= 7) {
    return Array.from({ length: total }, (_, index) => index + 1);
  }
  const pages: (number | string)[] = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push("left-ellipsis");
  for (let page = start; page <= end; page += 1) pages.push(page);
  if (end < total - 1) pages.push("right-ellipsis");
  pages.push(total);
  return pages;
}

export default function Pagination({ currentPage, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(currentPage, totalPages);

  const baseClass =
    "min-w-9 h-9 px-3 flex items-center justify-center rounded-md text-sm border transition-colors cursor-pointer";

  return (
    <nav className="flex items-center justify-center gap-2 flex-wrap" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`${baseClass} border-background-200 text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:border-background-200`}
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
      </button>

      {pages.map((page) =>
        typeof page === "number" ? (
          <button
            key={page}
            type="button"
            onClick={() => onChange(page)}
            className={`${baseClass} ${
              page === currentPage
                ? "border-primary-500 bg-primary-500 text-white"
                : "border-background-200 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
            }`}
          >
            {page}
          </button>
        ) : (
          <span key={page} className="px-1 text-foreground-400">
            …
          </span>
        )
      )}

      <button
        type="button"
        onClick={() => onChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`${baseClass} border-background-200 text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:border-background-200`}
      >
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </nav>
  );
}